import TableHeader from '@tiptap/extension-table-header';
import { ReactNodeViewRenderer } from '@tiptap/react';

import { TableCellRenderer } from '../../../components';

export const TableHeaderExtension = TableHeader.extend({
  addNodeView() {
    return ReactNodeViewRenderer(TableCellRenderer, {
      as: 'th',
      className: 'tiptap-table-cell',
      stopEvent: () => false, // This is added to allow the cell to be selected & resized
    });
  },
});
